export const DEFAULT_VALUES = {
  HOURSTART: 8,
  HOUREND: 17,
  STEP: 15,
  SHOWWEEKEND: 0,
  ISWEEK: false,
  MAX_FILE_SIZE: 10,
  NUMBER_MONTH_DELETE_IMAGE: 6,
  NUMBER_MINUTE_CLOSE_ACTION: 120,
  NUMBER_DAYS_SHOW: 5,
};

export const CALENDAR_CONST = {
  WEEKDAYS: 7,
  WEEKDAYSWITHOUTWEEKEND: 5,
};